import { deleteGoals as _deleteGoals } from '@griply/services';
import { ID, TaskLinkFields } from '@griply/types';
import {
  collection,
  deleteDoc,
  doc,
  Firestore,
  getDocs,
  orderBy,
  serverTimestamp,
  updateDoc,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';

import { getAuthentication, getDatabase, query, where } from './helpers';

export const deleteGoals = async (goalIds: ID[]): Promise<void> => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const uid = user.uid;

  await _deleteGoals({
    goalIds,
    uid,
    collection,
    doc,
    deleteDoc,
    updateDoc,
    query,
    where,
    orderBy,
    serverTimestamp,
    getDocs: async (q) =>
      getDocs(q as Parameters<typeof getDocs>[0]) as unknown as {
        docs: ReadonlyArray<{
          ref: ReturnType<typeof doc>;
          data: () => TaskLinkFields;
        }>;
      },
    db: getDatabase(),
    writeBatch: (_db) => writeBatch(_db as Firestore),
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.DeleteGoals,
        error,
        uid,
      }),
  });
};
